var _g, _path, _path2, _path3, _defs;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgVs = function SvgVs(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 136,
    viewBox: "0 0 78 136",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_3294_2858)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 48,
    width: 40,
    height: 40,
    rx: 12,
    fill: "url(#paint0_radial_3294_2858)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 49,
    width: 38,
    height: 38,
    rx: 11,
    stroke: "#5D7B9E",
    strokeWidth: 2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 0L37.5 0L39 48H35L36.5 0Z",
    fill: "#5D7B9E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 136L36.5 136L35 88L39 88L37.5 136Z",
    fill: "#5D7B9E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.888 73L28.36 63.28H29.701L32.572 71.272L35.425 63.28H36.784L33.256 73H31.888ZM41.6761 73.261C40.5361 73.261 39.5971 73.015 38.8591 72.523C38.1271 72.031 37.6771 71.347 37.5091 70.471L38.8591 70.246C39.0031 70.798 39.3301 71.239 39.8401 71.569C40.3561 71.893 40.9921 72.055 41.7481 72.055C42.4861 72.055 43.0681 71.902 43.4941 71.596C43.9201 71.284 44.1331 70.861 44.1331 70.327C44.1331 70.027 44.0641 69.784 43.9261 69.598C43.7941 69.406 43.5211 69.229 43.1071 69.067C42.6931 68.905 42.0751 68.713 41.2531 68.491C40.3711 68.251 39.6811 68.011 39.1831 67.771C38.6851 67.531 38.3311 67.255 38.1211 66.943C37.9111 66.625 37.8061 66.238 37.8061 65.782C37.8061 65.23 37.9621 64.747 38.2741 64.333C38.5861 63.913 39.0181 63.589 39.5701 63.361C40.1221 63.127 40.7641 63.01 41.4961 63.01C42.2281 63.01 42.8821 63.13 43.4581 63.37C44.0401 63.604 44.5081 63.934 44.8621 64.36C45.2161 64.786 45.4261 65.281 45.4921 65.845L44.1421 66.088C44.0521 65.518 43.7671 65.068 43.2871 64.738C42.8131 64.402 42.2101 64.228 41.4781 64.216C40.7881 64.198 40.2271 64.33 39.7951 64.612C39.3631 64.888 39.1471 65.257 39.1471 65.719C39.1471 65.977 39.2251 66.199 39.3811 66.385C39.5371 66.565 39.8191 66.736 40.2271 66.898C40.6411 67.06 41.2291 67.237 41.9911 67.429C42.8851 67.657 43.5871 67.897 44.0971 68.149C44.6071 68.401 44.9701 68.698 45.1861 69.04C45.4021 69.382 45.5101 69.805 45.5101 70.309C45.5101 71.227 45.1681 71.95 44.4841 72.478C43.8061 73 42.8701 73.261 41.6761 73.261Z",
    fill: "#5D7B9E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_3294_2858",
    x: -63,
    y: -32,
    width: 200,
    height: 200,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_3294_2858"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_3294_2858",
    result: "effect2_dropShadow_3294_2858"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3294_2858",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3294_2858",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.1278 56.4165) rotate(44.7841) scale(50.8091 55.049)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.770833,
    stopColor: "#6EBFF4",
    stopOpacity: 0.57
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4690D5",
    stopOpacity: 0.37
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVs, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/vs.50d92c73.svg";
export { ForwardRef as ReactComponent };